import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImagePlatinumCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Platinum Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-platinum-card.png',
  show: true,
  position: 'right'
};

export const BannerContentPlatinumCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Platinum Card Member',
  subtitle: ''
};

export const BannerPlatinumCardMocks: CardCarouselBanner = {
  labels: BannerContentPlatinumCardMocks,
  image: BannerImagePlatinumCardMocks
};
